import { AuthedAxiosRequests } from 'features/auth'
import { GeckoComponentRect } from 'types'

export interface BinBounds {
  angles: number[]
  x_end: number
  x_start: number
  y_end: number
  y_start: number
}

export interface BinBoundsData {
  angles: number[]
  xEnd: number
  xStart: number
  yEnd: number
  yStart: number
}

export interface Annotation {
  approved: boolean
  ascan_end: number
  ascan_start: number
  bin_bounds: BinBounds
  created_at: string
  damage_mechanism: string
  id: string
  orientation: string
  run_name: string
  sensor_end: number
  sensor_start: number
  user: string
}

export interface AnnotationData {
  approved: boolean
  ascanEnd: number
  ascanStart: number
  binBounds: BinBoundsData
  createdAt: string
  damageMechanism: string
  id: string
  orientation: string
  runName: string
  sensorEnd: number
  sensorStart: number
  user: string
}

export interface DamageAnnotationData {
  annotations: Annotation[]
  source: string
}

export interface DamageAnnotation {
  annotation: AnnotationData
  geometry: GeckoComponentRect
  name: string
}

export const toggleApprovedDamageAnnotation = async (
  slug: string | undefined,
  annotation: AnnotationData,
  apiUrl: string,
  axios: AuthedAxiosRequests
) => {
  return await axios.patch(
    `${apiUrl}/api/v1/annotations/${slug}/${annotation.runName}/${annotation.id}/toggle-approved`,
    undefined,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  )
}
